import { BusinessOrderInfo, CustomerOrderInfo, MaritimeOrderInfo, OrderInfo, OrderInfoType } from "./OrderInformation";


export function isMaritimeOrderInfo(arg: any): arg is MaritimeOrderInfo {
    return arg?.type === OrderInfoType.MaritimeOrderInfo;
}

export function isBusinessOrderInfo(arg: any): arg is BusinessOrderInfo {
    return arg?.type === OrderInfoType.BusinessOrderInfo;
}

export function isCustomerOrderInfo(arg: any): arg is CustomerOrderInfo {
    return arg?.type === OrderInfoType.CustomerOrderInfo;
}

/**
 * MaritimeOrderInfoとBusinessOrderInfoとCustomerOrderInfoをOrderInfoへ寄せる（型付け用）
 */
export function parseOrderInfo(order: any): OrderInfo {

    if (isMaritimeOrderInfo(order) || isBusinessOrderInfo(order) || isCustomerOrderInfo(order)) {
        return order as OrderInfo;
    } else {
        throw new Error("Cannot parse to OrderInfo");
    }
}